import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class ShopPartnerDeclareInfoAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getShopPartnerDeclareInfoList', {
      url: '/admin/financeData/employeeList',
      name: 'list',
      label: '列表'
    }],
    // ['updateShopPartnerDeclareInfo', {
    //   url: '/admin/financeData/shopEdit',
    //   name: 'edit',
    //   label: '编辑店铺申报'
    // }],

     ['exportExcelShopPartnerDeclareInfoList', {
      url: '/admin/financeData/exportEmployee',
      name: 'export-excel',
      label: '导出'
    }],
    // ['addShopPartnerDeclareInfo', {
    //   url: '/admin/quickReply/add',
    //   name: 'add',
    //   label: '添加店铺申报'
    // }],
    // ['deleteShopPartnerDeclareInfo', {
    //   url: '/admin/quickReply/delete',
    //   name: 'delete',
    //   label: '删除店铺申报'
    // }],

  ])
  // 店铺申报列表
  public getShopPartnerDeclareInfoList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getShopPartnerDeclareInfoList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // // 修改店铺申报
  // public updateShopPartnerDeclareInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('updateShopPartnerDeclareInfo').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 导出店铺申报
  public exportExcelShopPartnerDeclareInfoList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('exportExcelShopPartnerDeclareInfoList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
  // 添加店铺申报
  // public addShopPartnerDeclareInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('addShopPartnerDeclareInfo').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 删除店铺申报
  // public deleteShopPartnerDeclareInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deleteShopPartnerDeclareInfo').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
}